import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const MANIFESTO_IMG =
  "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=1600&q=80";

export default function Manifesto({ t }) {
  return (
    <section data-testid="manifesto-section" className="relative mx-auto max-w-7xl px-6 py-28 md:py-40">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: EASE }}
      >
        <p data-testid="manifesto-overline" className="mb-4 font-display text-xs font-bold uppercase tracking-[0.25em] text-flame md:text-sm">
          {t.overline}
        </p>
        <h2 data-testid="manifesto-heading" className="font-display text-4xl font-bold tracking-tight text-bone sm:text-5xl lg:text-6xl">
          {t.heading}
        </h2>
      </motion.div>

      <div className="mt-24 space-y-28 md:mt-32 md:space-y-40">
        {t.chapters.slice(0, 2).map((c, i) => (
          <Chapter key={c.num} chapter={c} align={i % 2 === 0 ? "left" : "right"} />
        ))}
      </div>

      <motion.figure
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.2, ease: EASE }}
        className="relative my-28 overflow-hidden md:my-40"
        data-testid="manifesto-visual"
      >
        <img
          src={MANIFESTO_IMG}
          alt="Persone in sync"
          className="h-[55vh] w-full object-cover md:h-[70vh]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-void via-transparent to-void/60" />
        <div
          className="absolute inset-0"
          style={{ background: "radial-gradient(ellipse at 35% 45%, transparent 0%, rgba(26,26,20,0.45) 100%)" }}
        />
      </motion.figure>

      <div className="space-y-28 md:space-y-40">
        {t.chapters.slice(2).map((c, i) => (
          <Chapter key={c.num} chapter={c} align={i % 2 === 0 ? "left" : "right"} />
        ))}
      </div>
    </section>
  );
}

function Chapter({ chapter, align }) {
  return (
    <motion.article
      data-testid={`manifesto-chapter-${chapter.num}`}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: EASE }}
      className={`relative max-w-2xl ${align === "right" ? "ml-auto text-left md:pr-8" : "md:pl-8"}`}
    >
      <span
        aria-hidden
        className={`pointer-events-none absolute -top-16 select-none font-display text-[9rem] font-black leading-none text-black/[0.06] md:-top-24 md:text-[13rem] ${
          align === "right" ? "-right-4" : "-left-6"
        }`}
      >
        {chapter.num}
      </span>
      <div className="relative">
        <span className="mb-6 block font-display text-sm font-bold tracking-[0.3em] text-flame">
          {chapter.num}
        </span>
        <h3 className="mb-6 font-display text-2xl font-bold tracking-tight text-bone sm:text-3xl lg:text-4xl">
          {chapter.title}
        </h3>
        <p className="text-base leading-relaxed text-ash md:text-lg">{chapter.text}</p>
      </div>
    </motion.article>
  );
}
